
import { TrendingUp, Repeat, User } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      path: '/statistics',
      icon: TrendingUp,
      label: 'Insights'
    },
    {
      path: '/app',
      icon: Repeat,
      label: 'Daily Rituals'
    },
    {
      path: '/settings',
      icon: User,
      label: 'You'
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/90 backdrop-blur-sm border-t border-soft-blue/30 px-4 py-3 z-50">
      <div className="flex justify-around items-center max-w-md mx-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center gap-2 p-2 transition-all duration-200 ${
                isActive ? 'scale-105' : 'hover:scale-105'
              }`}
            >
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                isActive 
                  ? 'bg-vibrant-orange shadow-lg' 
                  : 'bg-deep-blue shadow-sm'
              }`}>
                <Icon className="w-5 h-5 text-white" />
              </div>
              <span className={`text-xs font-medium ${
                isActive ? 'text-deep-blue' : 'text-deep-blue/70'
              }`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavigation;
